<template>
  <div v-if="((isZonesLayout || isCategoriesMode || isEventLive) && elsCount) || unassignedCount || unassignedGa">
    <h2 class="text-base">Categories</h2>
    <div v-if="assignedCount > 0 && (isZonesLayout || isCategoriesMode || isEventLive)">
      <b>{{ assignedCount }}</b>
      categorized seats
      <template v-for="(assignedCat, index) in assignedList">
        <div v-if="assignedCat.category !== undefined" :key="index" class="flex gap-1">
          <div class="w-4 h-4" :style="{ 'background-color': assignedCat.category.color }"></div>
          <span>{{ assignedCat.category.name }} - {{ assignedCat.count }}</span>
        </div>
      </template>
    </div>
    <div v-if="unassignedCount" class="text-red-600">
      <b>{{ unassignedCount }}</b>
      uncategorized seats
    </div>
    <div v-if="unassignedGa" class="text-red-600">
      <b>{{ unassignedGa }}</b>
      uncategorized GA
    </div>
    <SMButton
      v-if="isCategoriesMode"
      icon="cached"
      label="Reload Categories"
      type="primary"
      class="mt-2"
      @click.prevent.stop="refreshCategoryList"
    />
  </div>
</template>
<script setup lang="ts">
import { EVENTSTATUS } from '@/constants';
import Application from '@/core/application';
import { useGetters, useState } from '@/store/useStore';
import sumBy from 'lodash/sumBy';
import { computed, shallowRef } from 'vue';
import SMButton from '../ui/SMButton.vue';

const app = Application.instance;

defineProps({
  isCategoriesMode: Boolean,
});

const elsCount = shallowRef(app.seatmap.getVisibleSeats(app.currentSection?.uuid));
const { assignedList, unassignedCount, unassignedGa } = useState('categories');
const { isZonesLayout } = useGetters('settings');

const assignedCount = computed(() => sumBy(assignedList.value, (a) => a.count));
const isEventLive = computed(() => app.props.status === EVENTSTATUS.PUBLISHED);

const refreshCategoryList = () => {
  app.refreshCategoryList(true);
};
</script>
